import { __assign, __awaiter, __generator } from "tslib";
import getArtStoreApi from './artStoreApi';
import { ARTSTORE_PUBSUB_ENUMS, ART_STORE, cartItemsStatuses, SECTIONS_ID, ALBUMS, } from '../constants';
import wixAppsApi from './wixAppsApi';
import ProGalleryStore from '../viewerScript/ProGalleryStore';
import { translationUtils, experimentsWrapper, } from '@wix/photography-client-lib';
import CartApi from './cartStorageApi';
export var widgetType = {
    gallery: 'GALLERY',
    cart: 'CART',
};
var ArtStoreManager = /** @class */ (function () {
    function ArtStoreManager(context) {
        this.shouldSkipItems = function (wixCodeApi) {
            return !!wixCodeApi.location.query.skipItems;
        };
        this.context = context;
        this.pagesState = {
            showCheckout: false,
            showCart: false,
            showShopEditor: false,
            showStorePopupMessage: false,
        };
        this.cartStorageKey = 'artStoreCartCount';
        this.activeStoreWidget = null;
        this.activeWidgets = [];
        this.cartApi = new CartApi();
        this.appDefId = ART_STORE.ARTSTORE_APP_DEFINITION_ID;
        this.additionalProviderParams = null;
    }
    ArtStoreManager.prototype.initTranslationsIfNeeded = function () {
        return __awaiter(this, void 0, void 0, function () {
            var translations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.translations) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getTranslations()];
                    case 1:
                        translations = _a.sent();
                        this.translations = translations;
                        translationUtils.setTranslations(translations);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ArtStoreManager.prototype.initCartApiIfNeeded = function (isSSR) {
        if (isSSR === void 0) { isSSR = false; }
        // in SSR we cant access localStorage, to avoid errors use default cartApi.
        if (isSSR) {
            this.cartApi = {
                isSsrMock: true,
                initIfNeeded: function () { },
                clearAll: function () { },
                addToCart: function () { },
                updateCartItem: function () { },
                removeCartItem: function () { },
                getCartItems: function () { return []; },
                getCartItemsCount: function () { return 0; },
            };
        }
        else if (this.cartApi && this.cartApi.isSsrMock) {
            this.cartApi = new CartApi();
        }
        var context = this.context.getContext();
        this.cartApi.initIfNeeded(context);
    };
    // at each point only one widget is responsible for opening store pages (Cart, Checkout, edit modal..) - this widget is the activeStoreWidget
    // there is 2 ways to manage activeWidgets and activeStoreWidget:
    // art-store: old OOI flow, we have active widget list from createControllers so we use setActiveWidgetIfNeeded function.
    // albums: new OOI flow, we dont have list of widgets, every widget that get rendered add himself with addStoreWidget.
    ArtStoreManager.prototype.addStoreWidget = function (_a) {
        var setProps = _a.setProps, compId = _a.compId, type = _a.type;
        if (!this.activeStoreWidget && type === widgetType.cart) {
            // at start cart widget is the active widget
            this.activeStoreWidget = { setProps: setProps, compId: compId };
        }
        if (!this.activeWidgets.find(function (widget) { return widget.compId === compId; })) {
            // new widget - add it to the list
            this.activeWidgets.push({ compId: compId, setProps: setProps });
        }
    };
    ArtStoreManager.prototype.setActiveWidgetIfNeeded = function (activeWidgets) {
        if (!this.activeWidgets.length) {
            this.activeWidgets = activeWidgets;
        }
        if (!this.activeStoreWidget) {
            var cartWidget = this.activeWidgets.find(function (widget) { return widget.type === ART_STORE.CART_WIDGET_ID; });
            var galleryWidget = this.activeWidgets.find(function (widget) { return widget.type === ART_STORE.GALLERY_WIDGET_ID; });
            if (cartWidget || galleryWidget) {
                this.activeStoreWidget = cartWidget || galleryWidget;
            }
        }
    };
    ArtStoreManager.prototype.getConsentPolicy = function (wixCodeApi) {
        try {
            var query = wixCodeApi.location.query;
            if (query && query['consent-policy']) {
                var consentPolicy = JSON.parse(decodeURIComponent(query['consent-policy']));
                if (consentPolicy.policy) {
                    return consentPolicy;
                }
            }
        }
        catch (e) { }
        return wixCodeApi.user.getCurrentConsentPolicy();
    };
    ArtStoreManager.prototype.changeActiveStoreWidget = function (widget) {
        if (widget.compId !== this.activeStoreWidget.compId) {
            this.activeStoreWidget = widget;
        }
    };
    ArtStoreManager.prototype.openCart = function () {
        if (this.activeStoreWidget && !this.pagesState.showCart) {
            this.pagesState.showCart = true;
            this.activeStoreWidget.setProps({ pagesState: this.pagesState });
        }
    };
    ArtStoreManager.prototype.getSectionsUrl = function () {
        var context = this.context.getContext();
        var getSectionUrl = function (sectionId) {
            var appDefinitionId = ART_STORE.ARTSTORE_APP_DEFINITION_ID;
            return context.scopedGlobalSdkApis.site.getSectionUrl({
                sectionId: sectionId,
                appDefinitionId: appDefinitionId,
            });
        };
        return {
            thank_you_page: getSectionUrl(SECTIONS_ID.THANK_YOU),
            checkout_page: getSectionUrl(SECTIONS_ID.CHECKOUT),
        };
    };
    ArtStoreManager.prototype.getAdditionalProviderParams = function (wixCodeData, appDefId) {
        if (appDefId === void 0) { appDefId = ART_STORE.ARTSTORE_APP_DEFINITION_ID; }
        var appApi = wixAppsApi[appDefId];
        return appApi.getAdditionalParams(wixCodeData);
    };
    ArtStoreManager.prototype.getInstanceFromSettings = function (settings, appDefId) {
        if (appDefId === void 0) { appDefId = ART_STORE.ARTSTORE_APP_DEFINITION_ID; }
        var appApi = wixAppsApi[appDefId];
        return appApi.getInstanceFromSettings(settings);
    };
    ArtStoreManager.prototype.isAlbums = function (sp) {
        return !!(sp.booleans && sp.booleans.ignoreSavedConnectedProviders);
    };
    ArtStoreManager.prototype.getConnectedProvidersForThankYouPage = function (instance, styleParams, appDefId, wixCodeApi) {
        if (appDefId === void 0) { appDefId = ART_STORE.ARTSTORE_APP_DEFINITION_ID; }
        return __awaiter(this, void 0, void 0, function () {
            var query, _instance, connectedProviders_1, connectedProviders;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = wixCodeApi.location.query;
                        if (!(query &&
                            query.appDefId &&
                            query.appDefId === ALBUMS.ALBUMS_APP_DEF_ID)) return [3 /*break*/, 2];
                        _instance = this.getInstanceFromSettings(query, query.appDefId);
                        if (!_instance) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getConnectedProviders(_instance, styleParams, query.appDefId)];
                    case 1:
                        connectedProviders_1 = _a.sent();
                        return [2 /*return*/, connectedProviders_1];
                    case 2: return [4 /*yield*/, this.getConnectedProviders(instance, styleParams, appDefId)];
                    case 3:
                        connectedProviders = _a.sent();
                        return [2 /*return*/, connectedProviders];
                }
            });
        });
    };
    ArtStoreManager.prototype.getConnectedProviders = function (instance, styleParams, // TODO: remove
    appDefId) {
        if (appDefId === void 0) { appDefId = ART_STORE.ARTSTORE_APP_DEFINITION_ID; }
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl, appApi, connectedProviders;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isAlbums(styleParams) &&
                            appDefId === ART_STORE.ARTSTORE_APP_DEFINITION_ID) {
                            return [2 /*return*/, Promise.resolve(null)];
                        }
                        baseUrl = this.getBaseUrl();
                        appApi = wixAppsApi[appDefId];
                        return [4 /*yield*/, appApi.getConnectedProviders(instance, baseUrl)];
                    case 1:
                        connectedProviders = _a.sent();
                        return [2 /*return*/, Promise.resolve(connectedProviders)];
                }
            });
        });
    };
    ArtStoreManager.prototype.getLocale = function () {
        var scopedGlobalSdkApis = this.context.getContext().scopedGlobalSdkApis;
        if (scopedGlobalSdkApis &&
            scopedGlobalSdkApis.site &&
            scopedGlobalSdkApis.site.language) {
            return scopedGlobalSdkApis.site.language;
        }
        else {
            return 'en';
        }
    };
    ArtStoreManager.prototype.getTranslationsUrl = function (locale) {
        if (locale === void 0) { locale = 'en'; }
        return "https://static.parastorage.com/services/pro-gallery-statics/2.2007.0/assets/locale/pro-gallery/Gallery/Gallery_" + locale + ".json";
    };
    ArtStoreManager.prototype.getTranslations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var locale, translationsRaw;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        locale = this.getLocale();
                        return [4 /*yield*/, ProGalleryStore.getTranslations(this.getTranslationsUrl(locale))];
                    case 1:
                        translationsRaw = _a.sent();
                        return [2 /*return*/, translationsRaw];
                }
            });
        });
    };
    ArtStoreManager.prototype.initTranslations = function (setProps) {
        return __awaiter(this, void 0, void 0, function () {
            var translationsRaw;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTranslations()];
                    case 1:
                        translationsRaw = _a.sent();
                        translationUtils.setTranslations(translationsRaw);
                        setProps({ translations: translationsRaw });
                        return [2 /*return*/];
                }
            });
        });
    };
    ArtStoreManager.prototype.getChangeStoreFrameStateFunc = function (setProps) {
        var _this = this;
        return function (frame, newFrameState) {
            var pagesState = _this.pagesState;
            switch (frame) {
                case ARTSTORE_PUBSUB_ENUMS.CART:
                    if (newFrameState) {
                        _this.openCart();
                        return;
                    }
                    pagesState.showCart = newFrameState;
                    break;
                case ARTSTORE_PUBSUB_ENUMS.CHECKOUT:
                    if (newFrameState) {
                        pagesState.showCart = false;
                        pagesState.showShopEditor = false;
                        pagesState.showStorePopupMessage = false;
                    }
                    pagesState.showCheckout = newFrameState;
                    break;
                case ARTSTORE_PUBSUB_ENUMS.EDITOR:
                    if (newFrameState) {
                        pagesState.showCheckout = false;
                        pagesState.showCart = false;
                        pagesState.showStorePopupMessage = false;
                    }
                    pagesState.showShopEditor = newFrameState;
                    break;
                case ARTSTORE_PUBSUB_ENUMS.STORE_POPUP_MESSAGE:
                    if (newFrameState) {
                        pagesState.showCheckout = false;
                        pagesState.showCart = false;
                        pagesState.showShopEditor = false;
                    }
                    pagesState.showStorePopupMessage = newFrameState;
                    break;
                default:
                    break;
            }
            _this.pagesState = pagesState;
            setProps({ pagesState: pagesState });
        };
    };
    ArtStoreManager.prototype.getInitalProps = function (_a, connectedProviders, appDefId, additionalProviderParams) {
        var _this = this;
        var compId = _a.compId, setProps = _a.setProps, type = _a.type, consentPolicy = _a.consentPolicy;
        if (additionalProviderParams === void 0) { additionalProviderParams = {}; }
        var baseSectionsUrl = this.getSectionsUrl();
        var sectionsUrls = additionalProviderParams.freeArtStore
            ? {}
            : wixAppsApi[appDefId].getSectionsUrlWithParams(baseSectionsUrl, additionalProviderParams, connectedProviders);
        var platformServices = this.context.getContext().platformServices;
        return {
            changeStoreFrameState: this.getChangeStoreFrameStateFunc(setProps),
            connectedProviders: connectedProviders,
            pgTranslations: this.translations,
            pgExperiments: experimentsWrapper.experiments,
            consentPolicy: consentPolicy,
            additionalProviderParams: additionalProviderParams,
            pagesState: {
                showCheckout: false,
                showCart: false,
                showShopEditor: false,
                showStorePopupMessage: false,
            },
            setActiveStoreWidget: function () {
                return _this.changeActiveStoreWidget({ compId: compId, setProps: setProps, type: type });
            },
            visitorId: platformServices.bi.visitorId,
            metaSiteId: platformServices.bi.metaSiteId,
            cartItemsData: {
                cartItems: this.cartApi.getCartItems(),
                cartItemsCount: this.cartApi.getCartItemsCount(),
            },
            sectionsUrls: sectionsUrls,
            locale: this.getLocale(),
            ready: true,
            baseUrl: this.getBaseUrl(),
        };
    };
    ArtStoreManager.prototype.getBaseUrl = function () {
        var baseUrl = this.context.getContext().scopedGlobalSdkApis.location
            .baseUrl;
        var baseUrlParts = baseUrl.split('/');
        return baseUrlParts.slice(0, 3).join('/');
    };
    ArtStoreManager.prototype.initStoreWixCodeApi = function (settings, sp, appDefId) {
        return __awaiter(this, void 0, void 0, function () {
            var instance, additionalProviderParams;
            return __generator(this, function (_a) {
                instance = this.getInstanceFromSettings(settings, appDefId);
                additionalProviderParams = this.getAdditionalProviderParams(settings, appDefId);
                this.additionalProviderParams = additionalProviderParams;
                this.appDefId = appDefId;
                if (additionalProviderParams && additionalProviderParams.freeArtStore) {
                    return [2 /*return*/, Promise.resolve({ additionalProviderParams: additionalProviderParams })];
                }
                return [2 /*return*/, this.getConnectedProviders(instance, sp, appDefId).then(function (connectedProviders) {
                        return { connectedProviders: connectedProviders, additionalProviderParams: additionalProviderParams };
                    })];
            });
        });
    };
    ArtStoreManager.prototype.updateItemValidation = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var items, mediaUrl, invalidItems, appsApi, params, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        items = this.cartApi.getCartItems();
                        mediaUrl = item.mediaUrl || item.itemUrl;
                        if (!mediaUrl) return [3 /*break*/, 5];
                        invalidItems = void 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        appsApi = wixAppsApi[this.appDefId];
                        params = this.additionalProviderParams || this.context.getContext();
                        return [4 /*yield*/, appsApi.getInvalidItemsForDownload(params, mediaUrl, this.getBaseUrl())];
                    case 2:
                        invalidItems = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [2 /*return*/];
                    case 4:
                        if (invalidItems && invalidItems.length) {
                            invalidItems.forEach(function (invalidItem) {
                                var _mediaUrl = invalidItem.mediaUrl;
                                var result = [];
                                Object.keys(items).forEach(function (uuid) {
                                    if (_mediaUrl === items[uuid].mediaUrl) {
                                        result.push(items[uuid]);
                                    }
                                });
                                result.forEach(function (_item) {
                                    return _this.cartApi.setItemStatus(_item.uuid, cartItemsStatuses.INVALID);
                                });
                            });
                            this.onCartItemsChange();
                        }
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ArtStoreManager.prototype.onCartItemsChange = function () {
        var cartItems = this.cartApi.getCartItems();
        var cartItemsCount = this.cartApi.getCartItemsCount();
        this.activeWidgets.forEach(function (_a) {
            var setProps = _a.setProps;
            setProps({
                cartItemsData: { cartItems: cartItems, cartItemsCount: cartItemsCount },
            });
        });
    };
    ArtStoreManager.prototype.navigateToHomePage = function (wixCodeApi) {
        var siteStructure = wixCodeApi.site.getSiteStructure({
            includePageId: true,
        });
        var homePage = siteStructure.pages.find(function (page) { return page.isHomePage; });
        if (homePage && homePage.id) {
            wixCodeApi.location.navigateTo({ pageId: homePage.id });
        }
    };
    ArtStoreManager.prototype.openPopup = function (_a) {
        var wixCodeApi = _a.wixCodeApi, compId = _a.compId, url = _a.url, options = _a.options;
        var openPersistentPopup = wixCodeApi.window.openPersistentPopup;
        var defaultOptions = {
            width: '100%',
            height: '100%',
            position: {
                origin: 'FIXED',
                placement: 'CENTER',
            },
        };
        openPersistentPopup &&
            openPersistentPopup(url, __assign(__assign({}, defaultOptions), options), compId);
    };
    ArtStoreManager.prototype.getStoreApi = function (wixCodeApi, compId) {
        var _this = this;
        return getArtStoreApi(function () { return _this.onCartItemsChange(); }, this.cartApi, function () { return _this.openCart(); }, function (item) { return _this.updateItemValidation(item); }, function () { return _this.navigateToHomePage(wixCodeApi); }, function (url, options) { return _this.openPopup({ wixCodeApi: wixCodeApi, compId: compId, url: url, options: options }); });
    };
    return ArtStoreManager;
}());
export default ArtStoreManager;
//# sourceMappingURL=ArtStoreViewerScriptManager.js.map